import { render, staticRenderFns } from "./IOTDataWarnings.vue?vue&type=template&id=363c48a3"
import script from "./IOTDataWarnings.vue?vue&type=script&lang=js"
export * from "./IOTDataWarnings.vue?vue&type=script&lang=js"
import style0 from "./IOTDataWarnings.vue?vue&type=style&index=0&id=363c48a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports